export function isWechat () {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return userAgent.match(/MicroMessenger/i) == 'micromessenger';
}

export function isIos () {
  return !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
}

export function urlParameter(name) {
  return new URLSearchParams(window.location.search).get(name) || '';
}

export function isJSONString(str) {
  if (typeof str === 'string') {
    try {
      const obj = JSON.parse(str);
      return typeof obj === 'object' && obj
    } catch(e) {
      return false;
    }
  }
  return false;
}

export function getNonceStr() {
  const charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let nonceStr = '';
  for (let i = 0; i < 16; i++) {
    const randomPoz = Math.floor(Math.random() * charSet.length);
    nonceStr += charSet.substring(randomPoz,randomPoz+1);
  }
  return nonceStr;
}
